import NmsPolicyTemplateModel from './NmsPolicyTemplateModel';
import NmsPolicyCollection from './NmsPolicyCollection';

class NmsPolicyTemplateCollection extends NmsPolicyCollection {
  get url() {
    return '/api/ui/alerting/policy-templates/nms';
  }

  get model() {
    return NmsPolicyTemplateModel;
  }
}

export default NmsPolicyTemplateCollection;
